document.addEventListener("DOMContentLoaded", function () {
  const faqButtons = document.querySelectorAll(".itel-faq-question");

  faqButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      const answer = button.nextElementSibling;

      if (!answer) return;

      button.classList.toggle("active");
      answer.classList.toggle("open");
    });
  });
});